import React from 'react';
import { LegacyRef } from 'react';
import { GatsbyLinkProps, Link } from 'gatsby';

import { resolveTitle } from './resolve-title';

export const LinkWithTitle = ({
  children,
  title: _title,
  ...props
}: GatsbyLinkProps<any> & {
  ref?: LegacyRef<Link<any>>;
}) => {
  const title = resolveTitle({ children, title: _title });
  return (
    <Link title={title} {...props}>
      {children ?? title}
    </Link>
  );
};
